import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import PersonelHome from "components/PersonelHome";
import Header from "components/header/Header";
import Footer from "components/Footer";
import ModalDialog from "components/elements/modal/ModalDialog";
import Login from "components/Login";
import Logout from "components/Logout";
import Faq from "components/Faq";
import ManagerHome from "components/ManagerHome";
import Profile from "components/Profile";
import FordOrganization from "components/fordOrganization/FordOrganization";
import Vision from "components/Vision";
import Guide from "components/guide/Guide";
import CompletedTrainingsContainer from "components/CompletedTrainingsContainer";
import Invoices from "components/invoices/Invoices";
import CalendarHome from "components/calendar";
import OrganisationActivities from "components/organisationActivities/OrganisationActivities";
import DealerInfo from "components/dealerInfo/DealerInfo";
import MyTeam from "components/myteam/MyTeam";
import OrganisationChart from "components/OrganisationChart";
import EvolutionPlan from "components/evolutionPlan/EvolutionPlan";
import SurveyContainer from "components/survey/SurveyContainer";
import Dashboard from "components/Dashboard";
import Competency from "components/competency/Competency";
import AnnouncementsContainer from "components/AnnouncementsContainer";
import IntroductionVideosContainer from "components/IntroductionVideosContainer";
import TrainingRequestsContainer from "./trainingRequests/TrainingRequestsContainer";
import PersonelCalendar from "components/calendar/PersonelCalendar";
import ManagerCalendar from "components/calendar/ManagerCalendar";
import PotentialTrainingsContainer from "./PotentialTrainingsContainer";
import RegisteredEmployeesContainer from "./RegisteredEmployeesContainer";
import EmployeeRolesContainer from "components/employeeRoles/EmployeeRolesContainer";
import EmployeeManagementContainer from "components/employeeManagement/EmployeeManagementContainer";
import InformationalVideosContainer from "components/informationalVideos/InformationalVideosContainer";
import TrainingCatalogContainer from "components/trainingCatalog/TrainingCatalogContainer";
import Employee360Container from "components/employee360/Employee360Container";
import EmployeeTrainingManagement from './employeeTrainingManagement/EmployeeTrainingManagement';
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import NotFound from "./errorPages/NotFound";
import AccessDenied from "./errorPages/AccessDenied";

class App extends Component {
  componentDidMount() {
    toastr.options = {
      positionClass: "toast-top-full-width",
      hideDuration: 300,
      timeOut: 5000,
    };
    toastr.clear();
  }

  render() {
    return (
      <>
        <Header />
        <Switch>
          <Route path="/" exact component={Dashboard} />
          <Route path="/dashboard/personnel" exact component={PersonelHome} />
          <Route path="/dashboard/manager" exact component={ManagerHome} />
          <Route path="/profile" exact component={Profile} />
          <Route path="/login" exact component={Login} />
          <Route path="/logout" exact component={Logout} />
          <Route path="/password-reset/:code?" exact component={Login} />
          <Route path="/faq" exact component={Faq} />
          <Route path="/ford-organization" exact component={FordOrganization} />
          <Route path="/vision" exact component={Vision} />
          <Route path="/guide" exact component={Guide} />
          <Route path="/my-team" exact component={MyTeam} />
          <Route path="/organisation" exact component={OrganisationChart} />
          <Route path="/evolution-plan/:userid?" component={EvolutionPlan} />
          <Route path="/survey" exact component={SurveyContainer} />
          <Route path="/dashboard" exact component={Dashboard} />
          <Route path="/competency/:serviceType?" exact component={Competency} />
          <Route
            path="/completed-trainings"
            exact
            component={CompletedTrainingsContainer}
          />
          <Route
            path="/training-requests"
            exact
            component={TrainingRequestsContainer}
          />
          <Route path="/invoices" exact component={Invoices} />
          <Route
            path="/org-activities"
            exact
            component={OrganisationActivities}
          />
          <Route path="/calendar" exact component={CalendarHome} />
          <Route path="/calendar/manager" exact component={ManagerCalendar} />
          <Route path="/calendar/personnel" exact component={PersonelCalendar} />
          <Route path="/dealer-info" exact component={DealerInfo} />
          <Route path="/announcements" exact component={AnnouncementsContainer} />
          <Route path="/employee-training-management" exact component={EmployeeTrainingManagement} />
          <Route
            path="/introduction-videos"
            exact
            component={IntroductionVideosContainer}
          />
          <Route
            path="/potential-trainings"
            exact
            component={PotentialTrainingsContainer}
          />
          <Route
            path="/employee-training-registrations"
            exact
            component={RegisteredEmployeesContainer}
          />
          <Route
            path="/employee-roles"
            exact
            component={EmployeeRolesContainer}
          />
          <Route
            path="/employee-management"
            exact
            component={EmployeeManagementContainer}
          />
          <Route
            path="/informational-videos"
            exact
            component={InformationalVideosContainer}
          />
          <Route
            path="/training-catalog"
            exact
            component={TrainingCatalogContainer}
          />
          <Route path="/employee-360" exact component={Employee360Container} />
          <Route path="/access-denied" exact component={AccessDenied} />
          <Route path="*" component={NotFound} />
        </Switch>
        <Footer />
        <ModalDialog />
      </>
    );
  }
}

export default App;
